import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Header */}
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft size={20} />
            <span>Go Back</span>
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-serif text-white mb-4">Privacy Policy</h1>
          <p className="text-zinc-400">Last Updated: April 2026</p>
        </div>

        <div className="space-y-10 text-zinc-300">
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Information We Collect</h2>
            <p className="mb-4">We collect:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Name</li>
              <li>Email</li>
              <li>Phone number</li>
              <li>Payment information</li>
              <li>Device information</li>
              <li>Usage data</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. How We Use Information</h2>
            <p className="mb-4">We use data to:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Process bookings</li>
              <li>Enable host listings</li>
              <li>Process payments</li>
              <li>Improve platform</li>
              <li>Prevent fraud</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Third-Party Services</h2>
            <p className="mb-4">We use:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Stripe (Payments)</li>
              <li>Analytics Providers</li>
              <li>Email providers</li>
            </ul>
            <p className="mt-4 text-zinc-500">These services have their own policies.</p>
          </section>

          <hr className="border-white/10" />

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Cookies</h2>
            <p className="mb-4">100Nook uses cookies for:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Login</li>
              <li>Analytics</li>
              <li>Performance</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 5 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Data Security</h2>
            <p className="text-zinc-400">We use industry-standard safeguards.</p>
          </section>

          <hr className="border-white/10" />

          {/* Section 6 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">6. User Rights</h2>
            <p className="mb-4">Users may:</p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Request deletion</li>
              <li>Update data</li>
              <li>Request access</li>
            </ul>
          </section>

          <hr className="border-white/10" />

          {/* Section 7 */}
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">7. Children's Privacy</h2>
            <p className="text-zinc-400">100Nook is not intended for users under 18.</p>
          </section>
        </div>

        {/* Footer CTA */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-zinc-500 text-sm">
            Questions about our privacy practices? Contact us at{' '}
            <a href="mailto:admin@100nook.com" className="text-[#D4AF37] hover:underline">
              admin@100nook.com
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
